import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../auth/AuthContext';
import { resolveAdsEntryPath } from './adsNavigation';

/**
 * /system/ads：導向第一個有權限的 Ads 子頁；無權限則回首頁（既有 guard 僅驗登入）。
 */
export default function AdsEntryRedirect() {
  const { permissions } = useAuth();
  const location = useLocation();
  const target = resolveAdsEntryPath(permissions);
  if (!target) {
    return <Navigate to="/" replace />;
  }
  return (
    <Navigate
      to={`${target}${location.search}${location.hash}`}
      replace
      state={location.state}
    />
  );
}
